// Libraries
var React = require('react');

// Styles
require('./Chevron.scss');
var triangle = require('images/triangle.svg');

class ChevronModule extends React.Component {
	render() {
		return (
            <div className={"chevron"}>		
                <div className={"chevron--left"}><img src={triangle} alt="" /></div>
                <div className={"chevron--right"}><img src={triangle} alt="" /></div>
            </div>
		)
	}
}

module.exports = ChevronModule;


// WEBPACK FOOTER //
// ./src/components/Footer/Chevron/ChevronModule.js